import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { TransportInvoiceDetailModel } from 'src/app/models/additional/transport-invoice-detail.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { FilterGlobalResponseModel } from 'src/app/models/responses/filter-global-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { TransportInvoiceDetailCaptureTableModel } from 'src/app/models/tables/additional/transport-invoice-detail-capture-table.model';
import { TransportInvoiceDetailTableModel } from 'src/app/models/tables/additional/transport-invoice-detail-table.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TransportInvoiceDetailService {

  constructor(private _httpClient: HttpClient) { }

  addDocumentsToTransporInvoice(transportInvoiceId: number, details: TransportInvoiceDetailModel[]): Observable<any> {
    return this._httpClient.post<any>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.transportInvoiceDetail.AddDocumentsToTransporInvoiceAsync}/${transportInvoiceId}`,
      details
    );
  }

  deleteSomeDetails(transportInvoiceId: number, details: TransportInvoiceDetailModel[]): Observable<any> {
    return this._httpClient.put<any>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.transportInvoiceDetail.DeleteSomeDetailsAsync}/${transportInvoiceId}`,
      details
    );
  }

  exportDetailConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean, differences: number): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString()).set('differences', differences);
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.transportInvoiceDetail.ExportDetailConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getColumnsForDetailConsultationAsync(): Observable<FilterGlobalResponseModel> {
    return this._httpClient.get<FilterGlobalResponseModel>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.transportInvoiceDetail.GetColumnsForDetailConsultationAsync}`
    );
  }

  getColumnsForDetail(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.transportInvoiceDetail.GetColumnsForDetailAsync}`
    );
  }


  getColumnsForSelection(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.transportInvoiceDetail.GetColumnsForSelectionAsync}`
    );
  }

  getDocumentsSelectionWithPagination(
    page: number,
    limit: number,
    columnSort: string | null,
    ascendant: boolean,
    filters: ColumnResponseModel[],
    providerId: number
  ): Observable<PagedResponseModel<TransportInvoiceDetailCaptureTableModel>> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant)
      .set('providerId', providerId);
    return this._httpClient.post<PagedResponseModel<TransportInvoiceDetailCaptureTableModel>>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.transportInvoiceDetail.GetDocumentsSelectionWithPaginationAsync}`,
      filters,
      { params: params }
    );
  }

  getTransportInvoicesDetailWithPagination(
    page: number,
    limit: number,
    columnSort: string | null,
    ascendant: boolean,
    transportInvoiceId: number
  ): Observable<PagedResponseModel<TransportInvoiceDetailCaptureTableModel>> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant)
      .set('transportInvoiceId', transportInvoiceId);
    return this._httpClient.get<PagedResponseModel<TransportInvoiceDetailCaptureTableModel>>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.transportInvoiceDetail.GetTransportInvoicesDetailWithPaginationAsync}`,
      { params: params }
    );
  }

  getTransportInvoicesDetailsForDetailConsultation(
    page: number,
    limit: number,
    columnSort: string | null,
    ascendant: boolean,
    filters: ColumnResponseModel[],
    differences: number = 1
  ): Observable<PagedResponseModel<TransportInvoiceDetailTableModel>> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant)
      .set('differences', differences);
    return this._httpClient.post<PagedResponseModel<TransportInvoiceDetailTableModel>>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.transportInvoiceDetail.GetTransportInvoicesDetailsForDetailConsultation}`,
      filters,
      { params: params }
    );
  }

  updateDetail(transportInvoiceId: number, detail: TransportInvoiceDetailModel): Observable<TransportInvoiceDetailModel> {
    return this._httpClient.put<TransportInvoiceDetailModel>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.transportInvoiceDetail.UpdateAsync}/${transportInvoiceId}`,
      detail
    );
  }
}
